import React from 'react';
import { css } from 'emotion';
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import { RichEditor as DesignRichEditor } from '@whalecloud/fdx';
import FormItem from "@whalecloud/page-builder-core/components/Render/components/FormItem";
import { makeEventProps } from '@whalecloud/page-builder-core/utils/common';
import { controls, richEditorRegExp } from '@utils/util';
import '../index.css';

const left = css({ textAlign: 'left' });
const RichEditor = props => {
  const { element, nameSpace } = props;
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { horizontalAlign = 'left' } = settings;
  const { rules = [] } = formSettings;
  const eventProps = makeEventProps(element.data.events, nameSpace);

  const ruleProps: any = {};
  if (rules.length > 0) {
    ruleProps.rules = [{ required: rules[0].required, validator: (rule, value) => richEditorRegExp(rule, value, rules[0]) }]
  }

  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (
        <div style={{ textAlign: horizontalAlign }}>
          <FormItem
            id={element.id}
            style={elementStyle}
            className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-richEditor', left)}
            {...formSettings}
            {...ruleProps}
          >
            <DesignRichEditor
              style={elementStyle}
              controls={controls}
              {...formItemSettings}
              {...eventProps}
              className={className}
            />
          </FormItem>
        </div>
      )}
    </ElementRoot>
  );
};

export default RichEditor;
